import { bootstrap } from '@/bootstrap.ts';
bootstrap();

import { createI18n } from 'vue-i18n';
import { bootStores, setupStatePersistence } from '@/stores/store.ts';
import { useAuthStore } from '@/stores/authentication.ts';
import * as yup from 'yup';
import { type Pinia } from 'pinia';
import { type Router } from 'vue-router';
import { type App } from 'vue';

import PrimeVue from 'primevue/config';

/*
import 'primevue/resources/themes/saga-blue/theme.css'; // theme
//import "primevue/resources/themes/saga-blue/theme.css"
//import 'primevue/resources/themes/bootstrap4-dark-blue/theme.css';
//import "primevue/resources/themes/aura-light-pink/theme.css";
//import "primevue/resources/themes/aura-dark-green/theme.css";
//import "primevue/resources/themes/md-light-indigo/theme.css"
//import 'primevue/resources/themes/aura-light-green/theme.css'
//import "primevue/resources/themes/aura-dark-blue/theme.css";
import 'primevue/resources/primevue.min.css';
*/
//import Aura from '@primevue/themes/aura';
//import Nora from '@primevue/themes/nora';
import Nora from '@primeuix/themes/nora';

import { definePreset } from '@primeuix/themes';
import 'primeicons/primeicons.css';

import Donut from 'vue-css-donut-chart';
import 'vue-css-donut-chart/dist/vcdonut.css';

import ConfirmationService from 'primevue/confirmationservice';
import DialogService from 'primevue/dialogservice';
import DynamicDialog from 'primevue/dynamicdialog';
import PVButton from 'primevue/button';
import PVCard from 'primevue/card';
import PVCheckbox from 'primevue/checkbox';
import PVColumn from 'primevue/column';
import PVDataTable from 'primevue/datatable';
import PVDatePicker from 'primevue/datepicker';
import PVDialog from 'primevue/dialog';
import PVDivider from 'primevue/divider';
import PVDropdown from 'primevue/dropdown';
import PVFocusTrap from 'primevue/focustrap';
import PVInlineMessage from 'primevue/inlinemessage';
import PVInputNumber from 'primevue/inputnumber';
//import PVInputSwitch from 'primevue/inputswitch';
import PVInputSwitch from 'primevue/toggleswitch';
import PVInputText from 'primevue/inputtext';
import PVMessage from 'primevue/message';
import PVPaginator from 'primevue/paginator';
import PVPanel from 'primevue/panel';
import PVProgressBar from 'primevue/progressbar';
import PVRipple from 'primevue/ripple';
import PVSelect from 'primevue/select';
import PVSpeedDial from 'primevue/speeddial';
import PVStyleClass from 'primevue/styleclass';
import PVTab from 'primevue/tab';
import PVTabList from 'primevue/tablist';
import PVTabPanel from 'primevue/tabpanel';
import PVTabPanels from 'primevue/tabpanels';
import PVTabs from 'primevue/tabs';
import PVTextarea from 'primevue/textarea';
import PVToastService from 'primevue/toastservice';
import PVTooltip from 'primevue/tooltip';
import { type ValidationErrors, type ValidationErrorMessage } from '@/types/Validation.ts';

import "tailwindcss";
import "tailwindcss-primeui";

import 'material-design-icons-iconfont/dist/material-design-icons.min.css';
import '@mdi/font/css/materialdesignicons.css';
//import 'material-design-icons-iconfont/dist/material-design-icons.css';
import '../sass/app.scss';
import '../css/base.css';

import { createApp, type Component } from 'vue';

import Vue2DatePicker from 'vue-datepicker-next';
import 'vue-datepicker-next/index.css';

import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';

import dayjs from 'dayjs';
import isoWeek from 'dayjs/plugin/isoWeek';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(isoWeek);
dayjs.extend(customParseFormat);

function setupV3(component:Component, router:Router|undefined, pinia:Pinia|undefined): App {
  
  const language = document.documentElement.lang;

  const i18n = createI18n({
    legacy: true,
    locale: language, //'en',
    fallbackLocale: 'en',
    messages: {
      en: {
        "verify-title": "Reset/Verify your account",
        "verify-success": "Your password has been reset.",
        "verify-password-label": "Password",
        "verify-password-confirm-label": "Confirm Password",
        "verify-error": "An error has occurred please contact support.",
        "verify-btn-submit": "Submit",

        "app-forgotten-success": "We have sent you an email to set a new password.",
        "app-forgotten-title": "Recover Password",
        "app-forgotten-email-label": "Email",
        "app-forgotten-confirm-email-label": "Confirm Email",
        "app-forgotten-btn-submit": "Submit"
      },
      de: {
        "verify-title": "Setzen Sie Ihr Konto zurück / überprüfen Sie es",
        "verify-success": "Dein Passwort wurde zurück gesetzt.",
        "verify-password-label": "Passwort",
        "verify-password-confirm-label": "Kennwort bestätigen",
        "verify-error": "Ein Fehler ist aufgetreten. Bitte wenden Sie sich an den Support.",
        "verify-btn-submit": "einreichen",

        "app-forgotten-success": "Wir haben Ihnen eine E-Mail gesendet, um ein neues Passwort festzulegen.",
        "app-forgotten-title": "Passwort-Wiederherstellung",
        "app-forgotten-email-label": "E-mail",
        "app-forgotten-confirm-email-label": "E-Mail-Adresse bestätigen",
        "app-forgotten-btn-submit": "Einreichen"
      },
      es: {
        "verify-title": "Restablecer / verificar su cuenta",
        "verify-success": "Tu contraseña ha sido restablecida.",
        "verify-password-label": "Contraseña",
        "verify-password-confirm-label": "Confirmar contraseña",
        "verify-error": "Se ha producido un error, póngase en contacto con soporte.",
        "verify-btn-submit": "Enviar",

        "app-forgotten-success": "Le hemos enviado un correo electrónico para establecer una nueva contraseña.",
        "app-forgotten-title": "Recuperar contraseña",
        "app-forgotten-email-label": "Correo electrónico",
        "app-forgotten-confirm-email-label": "Confirmar correo electrónico",
        "app-forgotten-btn-submit": "Enviar"
      }
    }
  });

  // Configure Yup locale messages
  yup.setLocale({
    mixed: {
      required: function() {
        return i18n.global.t('validations.required');
      }
    },
    string: {
      email: function() {
        return i18n.global.t('validations.email');
      },
      min: function({ min }) {
        return i18n.global.t('validations.min', { min });
      },
      max: function({ max }) {
        return i18n.global.t('validations.max', { max });
      }
    }
  });

  const app = createApp(component);

  app.config.errorHandler = (err, instance, info) => {

    // Handle the error globally
    console.error("Global error:", err);
    console.log("Vue instance:", instance);
    console.log("Error info:", info);
    
    // Add code for UI notifications, reporting or other error handling logic
  };
  
  app.use(i18n);
  if (pinia) {
    app.use(pinia);
    bootStores();
    setupStatePersistence();
  }

  if (router) app.use(router);

  const MyPreset = definePreset(Nora, {
    semantic: {
      primary: {
        50: '{blue.50}',
        100: '{blue.100}',
        200: '{blue.200}',
        300: '{blue.300}',
        400: '{blue.400}',
        500: '{blue.500}',
        600: '{blue.600}',
        700: '{blue.700}',
        800: '{blue.800}',
        900: '{blue.900}',
        950: '{blue.950}'
      },
      colorScheme: {
        light: {
          primary: {
            color: 'rgb(65, 143, 222)',
          },
          secondary: {
            color: 'rgb(245, 245, 245)',
          },
          highlight: {
            color: 'rgb(245, 245, 245)',
          },
        },
        dark: {
          color: 'rgb(245, 245, 245)',
          //                        color: '#F5F5F5',
        },
      }
    }
  });
  
  app.use(PrimeVue, {
    ripple:false,
    theme: {
      preset: MyPreset,
      options: {
        prefix: 'p',
        //        darkModeSelector: 'system',
        darkModeSelector: '.ym-dark', //system',
        cssLayer: false /*{
          name: 'primevue',
          order: 'theme, base, primevue'
        }*/
      }
    }
  });
  app.use(Donut);
  app.use(PVToastService);
  app.use(DialogService);
  app.directive('ripple', PVRipple);
  app.directive('styleclass', PVStyleClass);
  app.directive('focustrap', PVFocusTrap);
  app.directive('tooltip', PVTooltip);
  app.component('ConfirmationService', ConfirmationService);
  app.component('DynamicDialog', DynamicDialog);
  app.component('PVButton', PVButton);
  app.component('PVCard', PVCard);
  app.component('PVCheckbox', PVCheckbox);
  app.component('PVColumn', PVColumn);
  app.component('PVDataTable', PVDataTable);
  app.component('PVDatePicker', PVDatePicker);
  app.component('PVDialog', PVDialog);
  app.component('PVDivider', PVDivider);
  app.component('PVDropdown', PVDropdown);
  app.component('PVInlineMessage', PVInlineMessage);
  app.component('PVInputNumber', PVInputNumber);
  app.component('PVInputSwitch', PVInputSwitch);
  app.component('PVInputText', PVInputText);
  app.component('PVMessage', PVMessage);
  app.component('PVPaginator', PVPaginator);
  app.component('PVPanel', PVPanel);
  app.component('PVProgressBar', PVProgressBar);
  app.component('PVSelect', PVSelect);
  app.component('PVSpeedDial', PVSpeedDial);
  app.component('PVTab', PVTab);
  app.component('PVTabList', PVTabList);
  app.component('PVTabPanel', PVTabPanel);
  app.component('PVTabPanels', PVTabPanels);
  app.component('PVTabs', PVTabs);
  app.component('PVTextarea', PVTextarea);
  app.component('Vue2DatePicker', Vue2DatePicker);
  
  // Create a global validation mixin
  app.mixin({
    data() {
      return {
        validationErrors: {} as ValidationErrors, //{[key:string]:string|string[]},
      };
    },
    computed: {
      localTZ(): string { return new Date().toLocaleTimeString(undefined,{ timeZoneName:'short' }).split(' ')[2]; },
      locale(): string|null {
        const authStore = useAuthStore();
        return authStore.preferred_locale;
      },
    },
    methods: {
      asLocalDate(t ?: number): string {
        //      if (t > 3600) dayjs.unix(t).format('YYYY-MM-DD HH:mm:ss');
        if (t && t > 3600) return new Date(t*1000).toLocaleDateString(this.locale);
        return '';
      },
      asLocalDateTime(t ?: number): string {
        //      if (t > 3600) dayjs.unix(t).format('YYYY-MM-DD HH:mm:ss');
        if (t && t > 3600) return new Date(t*1000).toLocaleString(this.locale);
        return '';
      },
      asLocalDateTimeWithZone(t ?: number): string {
        if (t && t > 3600) return new Date(t*1000).toLocaleString(this.locale) + ' (' + this.localTZ +')';
        return '';
      },
      asLocalDateTimeDense(t ?: number):string {
        if (!t) return '';
        const td = new Date();
        if (t <= 3600) return '';
        const d = new Date(t*1000);
        if (d.getDay() != td.getDay()) {
          return d.toLocaleString(this.locale);// + ' (' + this.localTZ +')';      } else {
        } else {
          return d.toLocaleTimeString(undefined, { timeZoneName:'short' }).split(' ')[1];
        }
      },
      async validateWithYup(schema:yup.ObjectSchema<any>, data:any) {
        try {
          await schema.validate(data, { abortEarly: false });
          this.validationErrors = {};
          return true;
        } catch (err:unknown) {
          if (err instanceof yup.ValidationError) {
            const errors: {[key:string]: string} = {};
            if (err.inner) {
              err.inner.forEach(error => {
                errors[error.path as string] = error.message;
              });
            } else console.log("VALID", err);
            this.validationErrors = errors;
          } else {
            console.log("Unexpected", err);
          }
          return false;
        }
      },
      validateWithYupSync(schema:yup.ObjectSchema<any>, data:any):boolean {
        try {
          const r = schema.isValidSync(data, { abortEarly: false });
          this.validationErrors = {};
          return r;
        } catch (err:unknown) {
          if (err instanceof yup.ValidationError) {
            const errors: {[key:string]: string} = {};
            if (err.inner) {
              err.inner.forEach(error => {
                errors[error.path as string] = error.message;
              });
            } else console.log("VALID", err);
            this.validationErrors = errors;
          } else {
            console.log("Unexpected", err);
          }
          return false;
        }
      },
      getValidationError(field:string):ValidationErrorMessage {
        const m:ValidationErrorMessage|undefined = this.validationErrors[field];
        return m ?? '';
        //return this.validationErrors[field] ?? '';// || '';
      },
      hasValidationError(field:string) {
        return !!this.validationErrors[field];
      },
      clearValidationErrors() {
        this.validationErrors = {};
      },
      getValidationErrors():ValidationErrors {
        return this.validationErrors as ValidationErrors;
      },
    }
  });

  return app;
}

export function setup(component:Component, router:Router|undefined, pinia:Pinia|undefined): App {
  try {
    return setupV3(component, router, pinia);
  } catch(e) {
    console.log(e);
    throw e;
  }
};

